import { render, staticRenderFns } from "./BroadcastComponent.vue?vue&type=template&id=4cf5aad6&scoped=true"
import script from "./BroadcastComponent.vue?vue&type=script&lang=js"
export * from "./BroadcastComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf5aad6",
  null
  
)

export default component.exports